import { createListPage, createDetailPage } from 'pages/common'
import { api, actionCreators } from 'store/modules/regions'
import Content from './grid'
import Form from './form'

import { urls } from 'urls'

const PAGE = 'regions'

export const metadata = {
  icon: 'globe',
  page: PAGE,
  isSoftDelete: false,
  urls: urls[PAGE]
}

const RegionsListPage = createListPage({ metadata, api, actionCreators, Content })
const RegionsDetailPage = createDetailPage({ metadata, actionCreators, Form })

export { RegionsListPage, RegionsDetailPage }
